import Vue from 'vue'
import axios from 'axios'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

// archivos locales
import App from './App.vue'
import router from './Routes'
import store from './store/index'
import vuetify from './plugins/vuetify'
import Ls from "./services/ls";
import filters from './filters/';
import {aplicarApariencia} from './services/apariencia';

Vue.use(Toast, {
  position: "top-center",
  timeout: 6000,
  hideProgressBar: true,
  closeButton: "button",
  icon: true
});

// FIltros
for (let name in filters) {
  Vue.filter(name, filters[name]);
}

// La URL del backend se define en .env.development / .env.production (VUE_APP_API_URL).
const baseURL = (process.env.VUE_APP_API_URL || window.location.origin).replace(/\/+$/, "");
const baseURLApi = `${baseURL}/api`;
const baseURLStorage = `${baseURL}/storage`;
Vue.prototype.baseURL = baseURL;
Vue.prototype.baseURLApi = baseURLApi;
Vue.prototype.baseURLStorage = baseURLStorage;

axios.defaults.baseURL = baseURLApi;
axios.interceptors.request.use(config => {
  const token = Ls.get('token');
  config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

// El API responde 403 con este código mientras la contraseña sea temporal.
axios.interceptors.response.use(response => response, error => {
  const respuesta = error.response;

  if (respuesta && respuesta.status === 403 && respuesta.data && respuesta.data.codigo === 'CAMBIAR_PASSWORD'
      && router.currentRoute.name !== 'CambiarPassword') {
    router.push({name: 'CambiarPassword'});
  }

  return Promise.reject(error);
});

global.axios = axios;

// Logos, colores y fuente configurados en Administración → Apariencia.
aplicarApariencia(vuetify);

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App), store
}).$mount('#app')
